import { useEffect, useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import "../css/Category.css"; // ✅ import this CSS

const PALETTE = [
  "#E6F7EC",
  "#FFF3E6",
  "#F3E8FF",
  "#E8F7FF",
  "#FFF0F4",
  "#F7F9E9",
  "#F0FFF4",
  "#F4F7FF",
];

const GetAllCategories = () => {
  const [categories, setCategories] = useState([]);
  const { categoryId } = useParams();
  const stripRef = useRef(null);
  const leftArrowRef = useRef(null);
  const rightArrowRef = useRef(null);

  // Fetch all categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://goldenhides.in/api/category/all"
        );
        if (response.data?.categories) {
          setCategories(response.data.categories);
        }
      } catch (err) {
        console.error("Error fetching categories", err);
      }
    };
    fetchCategories();
  }, []);

  const getColorForId = (id) => PALETTE[id % PALETTE.length];

  const scrollByAmount = () => {
    const el = stripRef.current;
    if (!el) return 400;
    return Math.round(el.clientWidth * 0.6);
  };

  const scrollLeft = () =>
    stripRef.current?.scrollBy({ left: -scrollByAmount(), behavior: "smooth" });
  const scrollRight = () =>
    stripRef.current?.scrollBy({ left: scrollByAmount(), behavior: "smooth" });

  // Hide/show arrows when reaching edges
  useEffect(() => {
    const el = stripRef.current;
    if (!el) return;

    const update = () => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      if (leftArrowRef.current)
        leftArrowRef.current.style.visibility =
          el.scrollLeft > 8 ? "visible" : "hidden";
      if (rightArrowRef.current)
        rightArrowRef.current.style.visibility =
          el.scrollLeft < maxScroll - 8 ? "visible" : "hidden";
    };

    update();
    el.addEventListener("scroll", update);
    window.addEventListener("resize", update);

    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [categories]);

  return (
    <div className="category-wrapper mb-3">
      {/* Left arrow */}
      <button
        ref={leftArrowRef}
        className="category-scroll-btn left"
        onClick={scrollLeft}
        aria-label="Scroll left"
        style={{ visibility: "hidden" }}
      >
        <i className="bi bi-chevron-left"></i>
      </button>

      {/* Centered viewport */}
      <div className="category-viewport mx-auto">
        <div ref={stripRef} className="category-strip no-scrollbar">
          {/* All categories */}
          <Link
            to="/home/all/product/categories"
            className={`category-chip text-decoration-none ${
              !categoryId ? "category-chip-active" : ""
            }`}
            style={{
              background: !categoryId ? "#25493f" : "#fff",
              color: !categoryId ? "#fff" : "#154936",
            }}
          >
            <div className="category-chip-content">
              <div className="category-chip-title">All Categories</div>
              <div className="category-chip-sub">Shop now</div>
            </div>
          </Link>

          {/* Dynamic categories */}
          {categories.map((category) => {
            const active = Number(categoryId) === category.id;
            const bg = getColorForId(category.id);
            return (
              <Link
                key={category.id}
                to={`/home/product/category/${category.id}/${category.title}`}
                className={`category-chip text-decoration-none ${
                  active ? "category-chip-active" : ""
                }`}
                style={{
                  background: active ? "#25493f" : bg,
                  color: active ? "#fff" : "#154936",
                }}
              >
                <div className="category-chip-content">
                  <div className="category-chip-title">{category.title}</div>
                  <div className="category-chip-sub">Shop now</div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Right arrow */}
      <button
        ref={rightArrowRef}
        className="category-scroll-btn right"
        onClick={scrollRight}
        aria-label="Scroll right"
        style={{ visibility: "hidden" }}
      >
        <i className="bi bi-chevron-right"></i>
      </button>
    </div>
  );
};

export default GetAllCategories;
